import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { TypeORMError } from "./TypeORMError";
import { ObjectUtils } from "../util/ObjectUtils";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Thrown when repository for the given class is not found.
 */
export var RepositoryNotTreeError = /*#__PURE__*/function (_TypeORMError) {
  _inherits(RepositoryNotTreeError, _TypeORMError);
  var _super = _createSuper(RepositoryNotTreeError);
  function RepositoryNotTreeError(entityClass) {
    var _this;
    _classCallCheck(this, RepositoryNotTreeError);
    _this = _super.call(this);
    var targetName;
    if (InstanceChecker.isEntitySchema(entityClass)) {
      targetName = entityClass.options.name;
    } else if (typeof entityClass === "function") {
      targetName = entityClass.name;
    } else if (ObjectUtils.isObject(entityClass) && "name" in entityClass) {
      targetName = entityClass.name;
    } else {
      targetName = entityClass;
    }
    _this.message = "Repository of the \"".concat(targetName, "\" class is not a TreeRepository. Try to apply @Tree decorator on your entity.");
    return _this;
  }
  return _createClass(RepositoryNotTreeError);
}(TypeORMError);